import type { SnackbarKey } from "notistack";

import { actionCreator } from "../utils";

import type { ISnack } from "./reducer";

export const EnqueueSnackbarActionCreator = actionCreator<"ENQUEUE_SNACK", ISnack>("ENQUEUE_SNACK");
export const CloseSnackbarActionCreator = actionCreator<"CLOSE_SNACKBAR", { key?: SnackbarKey }>("CLOSE_SNACKBAR");
export const RemoveSnackbarActionCreator = actionCreator<"REMOVE_SNACKBAR", { key: SnackbarKey }>("REMOVE_SNACKBAR");

export type SnackAction =
  | ReturnType<typeof EnqueueSnackbarActionCreator>
  | ReturnType<typeof CloseSnackbarActionCreator>
  | ReturnType<typeof RemoveSnackbarActionCreator>;

export function enqueueSnackbar(notification: Omit<ISnack, "key">) {
  const key = new Date().getTime() + Math.random();

  return EnqueueSnackbarActionCreator({
    ...notification,
    key: (notification?.options?.key as string) || `${key}`,
  });
}
